import http from "@/http/aisea/axios";
const resource = "/enterprises/operations/accounts";

export default {
  /**
   * APIでoperationのアカウント一覧を取得する
   * @param {Object} [options] - オプション
   * @param {boolean} [options.is_responsible] - 担当者のみに絞る場合 true（デフォルト: undefined）
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationAccount[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  index({ is_responsible } = {}) {
    const params =
      is_responsible === undefined ? {} : { is_responsible };
    return http.get(`${resource}`, { params });
  },
};
